/* tslint:disable */
/* eslint-disable */
/**
 * ADMIN-SERVICE - REST API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.1.0-SNAPSHOT
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { AddressFromJSON, AddressToJSON, ResourceTagFromJSON, ResourceTagToJSON, } from './';
export function LocationSearchRequestFromJSON(json) {
    return LocationSearchRequestFromJSONTyped(json, false);
}
export function LocationSearchRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'tags': !exists(json, 'tags') ? undefined : (json['tags'].map(ResourceTagFromJSON)),
        'name': !exists(json, 'name') ? undefined : json['name'],
        'address': !exists(json, 'address') ? undefined : AddressFromJSON(json['address']),
        'networkId': !exists(json, 'networkId') ? undefined : json['networkId'],
        'active': !exists(json, 'active') ? undefined : json['active'],
        'nielsenArea': !exists(json, 'nielsenArea') ? undefined : json['nielsenArea']
    };
}
export function LocationSearchRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'tags': value.tags === undefined ? undefined : (value.tags.map(ResourceTagToJSON)),
        'name': value.name,
        'address': AddressToJSON(value.address),
        'networkId': value.networkId,
        'active': value.active,
        'nielsenArea': value.nielsenArea
    };
}
